import React from "react";
import styles from "./Media.module.scss";
import MediaCard from "components/cards/mediaCard/MediaCard";

const Media = () => {
  return (
    <div className={`mediaRef ${styles.artistMedia}`}>
      <h2 className={styles.title}>Media</h2>
      <div className={styles.mediaContainer}>
        <MediaCard />
        <MediaCard />
        <MediaCard />
      </div>
      <div className={styles.loadMore}>
        <button>Load More</button>
      </div>
    </div>
  );
};

export default Media;
